<!-- eslint-disable vue/no-unused-properties vue/no-undef-properties -->
<template>
  <!-- You can use the `BaseEdge` component to create your own custom edge more easily -->
  <BaseEdge :id="id"
            :style="style"
            :path="path[0]"
            :marker-end="markerEnd"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave" />

  <!-- Use the `EdgeLabelRenderer` to escape the SVG world of edges and render your own custom label in a `<div>` ctx -->
  <EdgeLabelRenderer>
    <div
      :style="{
        pointerEvents: 'all',
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${path[1]}px,${path[2]}px)`
      }"
      class="nodrag nopan">
      <button
        v-if="delete_available"
        :class="{ 'opacity-100': (edgeHover?.source == source && edgeHover?.target == target) || hover }"
        class="edgebutton opacity-0 bg-red-500 w-5 h-5 flex items-center justify-center text-white transition-all duration-500 ease-in-out"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        @click="events.deleteEdgeClick({ source: source, target: target })">
        <X class="-ml-[1px]" color="white" />
      </button>
    </div>
  </EdgeLabelRenderer>
</template>
<script setup>
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@vue-flow/core"
import { X } from "lucide-vue-next"

import { ref, computed } from "vue"

const props = defineProps({
  events: null,
  elements: null,
  edgeHover: null,
  source: null,
  target: null,
  sourceNode: null,
  targetNode: null,
  getConnectedSourceElements: null,
  id: {
    type: String,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  sourceX: {
    type: Number,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  sourceY: {
    type: Number,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  targetX: {
    type: Number,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  targetY: {
    type: Number,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  sourcePosition: {
    type: String,
    required: true
  },
  //eslint-disable-next-line vue/no-unused-properties
  targetPosition: {
    type: String,
    required: true
  },

  markerEnd: {
    type: String,
    required: false
  },
  style: {
    type: Object,
    required: false
  }
})

const path = computed(() => getSmoothStepPath(props))
const hover = ref(false)

const handleMouseEnter = () => {
  hover.value = true // Set hover to true
}

const handleMouseLeave = () => {
  hover.value = false // Set hover to true
}

const delete_available = computed(() => {
  let delete_available_calc = true
  if (props.targetNode.data.is_trigger_group_merge) {
    delete_available_calc = false
  }
  if (props.sourceNode.data.type == "operator") {
    delete_available_calc = false
  }
  if (props.targetNode.data.type == "operator") {
    delete_available_calc = false
  }
  if (props.targetNode.data.type == "split") {
    delete_available_calc = false
  }
  if (props.sourceNode.data.type == "split") {
    const connection_to_split = props.elements.find((el) => el.target == props.sourceNode.id)
    if (!connection_to_split) {
      delete_available_calc = false
    }
  }

  if (props.sourceNode.data.type == "parallel" || props.sourceNode.is_in_parallel_flow) {
    delete_available_calc = false
  }

  if (props.sourceNode.data?.type == "for" || props.sourceNode.data.node_in_loop) {
    delete_available_calc = false
  }

  if (props.getConnectedSourceElements(props.targetNode.id)[0]?.data?.type == "parallel") {
    delete_available_calc = false
  }

  if (props.targetNode.data.type == "condition") {
    delete_available_calc = false
  }

  if (props.targetNode.data.type == "merge") {
    const connection_from_merge = props.elements.find((el) => el.source == props.targetNode.id)
    if (!connection_from_merge) {
      delete_available_calc = false
    }
  }
  return delete_available_calc
})
</script>

<script>
export default {
  inheritAttrs: false
}
</script>

<style scoped>
.edgebutton {
  border-radius: 999px;
  cursor: pointer;
}
.edgebutton:hover {
  transform: scale(1.5);
  transition: all ease 0.5s;
  box-shadow:
    0 0 0 2px #10b98180,
    0 0 0 4px #10b981;
}
</style>
